// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__24sCm","legacyBtn":"MutateMid_legacyBtn__1jsC5"};